fx.ns("common.popups", class AddPagePopup extends fx.components.Popup{
    
    constructor()
    {
        super();
        this.contentWidth = 550;
        this.contentHeight = 330;
       
        this.closeOnClickBehind = true;
    }


    create()
    {
        super.create();
        this.okButton = new fx.components.Button({className : "filled", label : fx.text("J'ai compris")});
        this.text1 = new fx.components.Text({text: fx.text("Bravo ! Vous venez d'ajouter 2 pages"), className: "text1"});
        this.text2 = new fx.components.Text({text: fx.text("La fabrication d'un album nécessite <span>un nombre de pages multiple de 4.</span>"), className: "text2"});
        this.text3 = new fx.components.Text({text: fx.text("Si ce n'est pas le cas, 2 pages blanches seront ajoutées automatiquement à la fin de votre album lors de la fabrication."), className: "text3"});
        let vbox = new fx.components.VBox();
        this.addChild(new shared.component.Person(fx.get("assets").personAdvice), {width:200, height : 200, top : -100, left : "center"});
        vbox.addChild(this.text1, {width :"100%"});
        vbox.addChild(this.text2, {width :"100%"});
        vbox.addChild(this.text3, {width :"100%"});
        vbox.addChild(this.okButton, {width :260});
        this.addChild(vbox, {top: 110, width:"95%", left:"center"});
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
        this.on("ENTER", this.close, fx.keyboard);

    }

});